import { createApp, nextTick } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./tailwind.css";
import Vue3Toasity from "vue3-toastify";
import "vue3-toastify/dist/index.css";
import VueCookies from "vue-cookies";
import VueApexCharts from "vue3-apexcharts";
import Vue3PersianDatetimePicker from "vue3-persian-datetime-picker";

// import fontawesome
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {} from "@fortawesome/free-brands-svg-icons";
import { faEye, faFolderOpen, faHourglassHalf } from "@fortawesome/free-regular-svg-icons";
import {
  faXmark,
  faBars,
  faList,
  faHandshake,
  faWallet,
  faDashboard,
  faChartLine,
  faHomeAlt,
  faCog,
  faSlidersH,
  faSearch,
  faUser,
  faHistory,
  faPrint,
  faCalendarAlt,
  faSun,
  faMoon,
  faCirclePlus,
  faPlus,
  faXmarkSquare,
  faCheck,
  faTags,
  faCartArrowDown,
  faTruck,
  faBarcode,
  faChevronDown,
  faDolly,
  faChevronLeft,
  faChevronRight,
  faEllipsisV,
  faBoxesPacking,
  faListCheck,
  faWarehouse,
  faScrewdriverWrench,
  faQuestion,
  faExchange,
  faTable,
  faWifi,
  faBorderAll,
  faEdit,
} from "@fortawesome/free-solid-svg-icons";

library.add(
  faXmark,
  faBars,
  faList,
  faHandshake,
  faWallet,
  faDashboard,
  faChartLine,
  faHomeAlt,
  faCog,
  faSlidersH,
  faSearch,
  faUser,
  faHistory,
  faPrint,
  faCalendarAlt,
  faSun,
  faMoon,
  faCirclePlus,
  faPlus,
  faXmarkSquare,
  faCheck,
  faTags,
  faCartArrowDown,
  faFolderOpen,
  faTruck,
  faHourglassHalf,
  faBarcode,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faDolly,
  faEye,
  faEllipsisV,
  faBoxesPacking,
  faListCheck,
  faWarehouse,
  faScrewdriverWrench,
  faQuestion,
  faExchange,
  faTable,
  faWifi,
  faBorderAll,
  faEdit
);

const defaultTitle = "سامانه اموال";
router.afterEach((to) => {
  nextTick(() => {
    document.title = to.meta.title || defaultTitle;
  });
});

createApp(App)
  .component("font-awesome-icon", FontAwesomeIcon)
  .component('DatePicker', Vue3PersianDatetimePicker)
  .use(VueApexCharts)
  .use(store)
  .use(router)
  .use(Vue3Toasity, { rtl: true })
  .use(VueCookies)
  .mount("#app");
